<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-div v-bind='{...{},...{}}' :style='"background: var(--primary);"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container" >
                <template #default>   <m-nav-309 v-bind='{...{"sideMenuPosition":"store_nav","mainMenuPosition":"blog_nav","dashboardLink":"https:\/\/dash.darmangahfarhangian.ir\/dashboard","AuthLink":{"name":"Login"},"image":null,"showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-block","defaultPanel":null},...{}}' :style='""' class="text-center" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #footer>   </template>
                
                <template #menu-4>   <m-a v-bind='{...{"href":"https:\/\/dash.darmangahfarhangian.ir\/dashboard","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>حساب کاربری   </template>
                </m-a></template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-nav-309></template>
                </m-div></template>
                </m-div><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"\nbackground:var(--secondary) ;\nbackground-image: url(\"https:\/\/api.arair.ir\/storage\/asset\/bg.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="shadow container-fluid bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center py-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.darmangahfarhangian.ir\/storage\/assets\/9oCKJkcq5P76idTC3YTcfd6OTvzeGD3zx1MGOrRA.png1747121557.png","alt":"\u062f\u0631\u0645\u0627\u0646\u06af\u0627\u0647-\u0641\u0631\u0647\u0646\u06af\u06cc\u0627\u0646"},...{}}' :style='"width:200px ;\n"' class="img-fluid" ></m-img><m-h4 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>درمانگاه فرهنگیان   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>قیمت استثنایی کیفیت بی نظیر   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/www.instagram.com\/darmangah_farhangianandimeshk","target":"_self"},...{}}' :style='""' class="col-3" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.amudco.com\/storage\/icons\/insta.png","alt":"mix it web"},...{}}' :style='"height:50px;"' class="" ></m-img></template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-enamad-1 v-bind='{...{},...{}}' :style='""' class="" ></m-enamad-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>آدرس   <m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>اندیمشک کوی فرهنگیان خیابان باهنر نبش رودکی جنب پارک معلم   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>تماس با ما   <m-a v-bind='{...{"href":"tel:06142633000","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2" >
                <template #default>06142633000   </template>
                </m-a><m-a v-bind='{...{"href":"tel:09388009715","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2" >
                <template #default>09388009715   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-dark" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/mixitweb.com","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>ساخته شده با  ❤ توسط mixitweb   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/darmangahfarhangian.ir\/","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>تمام حقوق برای درمانگاه فرهنگیان محفوظ است .   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav309 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav309/Nav309'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mEnamad1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Enamad/Enamad1'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mDiv,mNav309,mA,mImg,mH4,mP,mEnamad1,mHr },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
